export const useSSOAuth = (redirect: string, redirectParam: Record<string, any> | null = null) => {
  const auth = useAuth();

  const query: Record<string, any> = {
    token: auth.access_token,
    mobile: auth.user.phone,
    redirect
  };

  if (redirectParam) {
    const encodedParam = JSON.stringify(redirectParam);
    query.redirectparam = encodedParam;
    console.log('[SSO] Redirect Param:', redirectParam);
    console.log('[SSO] Encoded Redirect Param:', encodedParam);
  }

  navigateTo({
    path: '/login-success',
    query
  });
};
